<template>
    <div ref="scroll">
        <FormGroup
            :name="name"
            :label="label"
            :as-row="asRow"
            :size="size"
            :required="required"
            :translatable="translatable"
            :errors="errors"
            :hide-validation="!showValidation">
            <template #default>
                <textarea
                    v-if="!apiKey"
                    :id="name"
                    v-model="model"
                    class="form-control"
                    :name="name"
                    rows="10" />

                <Editor
                    v-else
                    v-model="model"
                    :api-key="apiKey"
                    :init="{paste_data_images: true}"
                    menubar="file edit view insert format tools table tc help"
                    toolbar="undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | superscript subscript blockquote | link anchor"
                    plugins="lists paste link"
                    style="min-height: 500px;" />
            </template>

            <template #tips>
                <slot />
            </template>
        </FormGroup>
    </div>
</template>

<script>
import FieldMixin from '@/js/mixins/FieldMixin';

import FormGroup from '@/js/components/common/fields/FormGroup';
import Editor from '@tinymce/tinymce-vue';

export default {
    name: 'EditorField',

    components: {FormGroup, Editor},

    mixins: [FieldMixin],

    inheritAttrs: false,

    props: {
        value: {type: String, default: null},
        placeholder: {type: String, default: null},
    },

    created() {
        this.apiKey = process.env.MIX_TINY_MCE_KEY || undefined;
    },

    methods: {
        validate(value) {
            const errors = [];

            if (this.required && (value === null)) {
                errors.push(this.$t('validation.custom.required'));
            }

            if ((value !== null) && (this.$attrs.minlength) && (value.length < this.$attrs.minlength)) {
                errors.push(this.$t('validation.custom.minlength', {value: this.$attrs.minlength}));
            }

            this.modelErrors = errors;
        },

        focus() {
            // no focus from tinymce
            this.$refs.scroll.scrollIntoView(true);
        },
    },
};
</script>
